import { storeConfig } from "../config/store.config";
import { formatPrice } from "./utils";

// ---------------------------------------------------------------------------
// WhatsApp order flow (Phase 1 order method).
// Builds a professional, human-readable order message and opens WhatsApp
// addressed to the store's primary order number. No data is persisted.
// ---------------------------------------------------------------------------

export const buildOrderMessage = ({ items, customer, totals }) => {
  const lines = [];
  lines.push(`*NEW ORDER — ${storeConfig.storeName}*`);
  lines.push(`(${storeConfig.domain})`);
  lines.push("");
  lines.push("*Customer Details*");
  lines.push(`Name: ${customer.name}`);
  lines.push(`Mobile: ${customer.mobile}`);
  lines.push(
    `Address: ${customer.address}, ${customer.city}, ${customer.state} - ${customer.pincode}`
  );
  if (customer.note && customer.note.trim()) {
    lines.push(`Note: ${customer.note.trim()}`);
  }
  lines.push("");
  lines.push("*Order Items*");
  items.forEach((it, idx) => {
    lines.push(
      `${idx + 1}. ${it.name}`
    );
    lines.push(
      `   Size: ${it.size} | Color: ${it.color} | Qty: ${it.quantity}`
    );
    lines.push(
      `   Price: ${formatPrice(it.price)} x ${it.quantity} = ${formatPrice(
        it.price * it.quantity
      )}`
    );
  });
  lines.push("");
  lines.push("*Summary*");
  lines.push(`Items: ${totals.itemCount}`);
  lines.push(`Subtotal: ${formatPrice(totals.subtotal)}`);
  if (totals.discount > 0) {
    lines.push(`Discount (${totals.promoCode}): -${formatPrice(totals.discount)}`);
  }
  lines.push(`*Total: ${formatPrice(totals.total)}*`);
  lines.push("");
  lines.push("Please confirm availability and delivery details. Thank you!");
  return lines.join("\n");
};

export const openWhatsAppOrder = (payload) => {
  const message = buildOrderMessage(payload);
  const url = `https://wa.me/${storeConfig.whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;
  window.open(url, "_blank", "noopener,noreferrer");
  return message;
};

// Simple "chat with us" WhatsApp link (floating button / contact page).
export const whatsappChatUrl = (prefill) => {
  const base = `https://wa.me/${storeConfig.whatsappNumber}`;
  return prefill ? `${base}?text=${encodeURIComponent(prefill)}` : base;
};
